var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge01Midnight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#EC2A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7587 5.20062C11.3834 5.90456 11.7597 6.83424 11.7496 7.85143C11.729 9.98468 9.98471 11.729 7.85146 11.7496C6.83384 11.7596 5.90459 11.3834 5.20065 10.7586C5.04359 10.6195 4.7999 10.7542 4.83796 10.9607C5.29121 13.4129 7.44853 15.2675 10.0363 15.25C12.8521 15.2312 15.2312 12.8521 15.25 10.0363C15.2675 7.44893 13.413 5.29162 10.9608 4.83793C10.7547 4.79987 10.6195 5.04356 10.7587 5.20062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49371 7.05999L9.31928 7.30893C9.47546 7.35618 9.53584 7.54518 9.43565 7.67424L8.90584 8.35412L8.92421 9.216C8.92771 9.37918 8.76628 9.49512 8.61271 9.43912L7.80203 9.14512L6.98784 9.42906C6.83384 9.48287 6.67371 9.36518 6.6794 9.20199L6.70828 8.34056L6.18678 7.65412C6.0879 7.52418 6.15046 7.33562 6.30753 7.29056L7.13615 7.05168L7.6279 6.34337C7.72109 6.20949 7.91971 6.21037 8.01115 6.34556L8.49415 7.05956L8.49371 7.05999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge01Midnight);
export default __webpack_public_path__ + "static/media/badge_01_midnight.03d1897bc91b28dae053e433b47868d2.svg";
export { ForwardRef as ReactComponent };